import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import FormItemInput from "../../components/form-item/form-item-input";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import { Form } from "antd";
import FormCard from "../../components/card/FormCard";
import FormButton from "../../components/FormButton";
import { useNotify } from "../../helper/notify";
import { GetFullMediaPath, requireRules } from "../../helper/method";
import { statusShowMock, tokenMock } from "../../helper/mock";
import { $api } from "../../helper";
import { useNavigate, useParams, useSearchParams } from "react-router";
import FormItemInputNumber from "../../components/form-item/form-item-input-number";
import VideoCard from "../../components/card/VideoCard";
import MediaPreview from "../../components/MediaPreview";

export default function AddVideoForSeason() {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const params = useParams();
  const notify = useNotify();
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();
  const { mutate, isPending } = $api.useMutation(
    "post",
    "/site-api/v1/course-season-video/",
  );
  const update = $api.useMutation("put", "/site-api/v1/course-season-video/");
  const detail = $api.useMutation(
    "get",
    "/site-api/v1/course-season-video-detail/",
  );
  const [file, setFile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("ایجاد ویدیو");
    if (searchParams.get("u_id")) {
      detail.mutate({
        params: {
          query: {
            video_u_id: searchParams.get("u_id") ?? "",
          },
        },
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (detail.data?.data) {
      setFile([
        {
          file: undefined,
          fileUrl: GetFullMediaPath(detail.data.data.video ?? ""),
          id: detail.data.data.u_id,
        },
      ]);
      Object.entries(detail.data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value?.toString());
      });
    }
  }, [detail.data]);

  const onFinish = (
    values: {
      title: string;
      display_order: string;
      status: string;
    },
    redirect = true,
  ) => {
    // const xhr = new XMLHttpRequest();
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("status", values.status);
    formData.append("display_order", values.display_order);
    if (searchParams.get("u_id")) {
      formData.append("video_u_id", searchParams.get("u_id")?.toString() ?? "");
    } else {
      formData.append("season_u_id", params.id ?? "");
    }
    formData.append("video", file?.at(0)?.file ?? file?.at(0)?.fileUrl ?? "");
    //      xhr.upload.addEventListener("progress", (event) => {
    //     if (event.lengthComputable) {
    //       const percent = Math.round((event.loaded / event.total) * 100);
    //       setProgress(percent);
    //     }
    //   });
    if (!searchParams.get("u_id")) {
      mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate(`/video-list/${params.id}`);
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    } else {
      update.mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate(`/video-list/${params.id}`);
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    }
  };

  //   console.log(progress)

  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e, true)}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <FormCard
        subTitle="تعریف و تنظیمات پایه مربوط به ویدیو"
        title={`اطلاعات اصلی ویدیو (${searchParams.get("season_name")})`}
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            name={"title"}
            rules={requireRules("عنوان")}
            className="col-span-1"
            label="عنوان"
            inputProps={{
              placeholder: "لطفا عنوان خود را وارد کنید.",
            }}
          />
          <FormItemInputNumber
            name={"display_order"}
            rules={requireRules("ترتیب نمایش")}
            className="col-span-1"
            label="ترتیب نمایش"
            inputProps={{
              placeholder: "لطفا ترتیب نمایش خود را وارد کنید.",
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            rules={requireRules("وضعیت")}
            name={"status"}
            label="وضعیت"
            inputProps={{
              placeholder: "لطفا وضعیت نمایش محصول خود را انتخاب کنید.",
              options: statusShowMock,
            }}
          />
        </div>
      </FormCard>
      <FormCard subTitle="ویدیو مربوط به نمایش کاربر" title="ویدیو">
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <div className="col-span-1 flex h-fit flex-col gap-2">
            <VideoCard
              file={file}
              setFile={setFile}
              id="video-1"
              name="video"
              multiple={false}
            />
            <div className="grid grid-cols-4">
              {file?.map((e, i) => (
                <div className="w-40 h-40 col-span-1">
                  <MediaPreview
                    type="video"
                    id={e.id}
                    setFile={setFile}
                    mediaUrl={e.fileUrl}
                    key={"preview-category" + i}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </FormCard>
      <FormButton
        isPending={isPending || update.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
